import { LucideProps } from "lucide-react";
import { ForwardRefExoticComponent, RefAttributes } from "react";
import { NavigationItem } from "./NavigationItem";
import { cn } from "@/lib/utils";

interface Item {
  icon: ForwardRefExoticComponent<
    Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
  >;
  url: string;
  title: string;
}

interface ItemsProps {
  items: Item[];
  className?: string;
}

export const MobileNavigationItems = ({ items, className }: ItemsProps) => (
  <menu className={cn("flex flex-col gap-3 my-2", className)}>
    {items.map((item) => (
      <li>
        <NavigationItem
          item={item}
          className="flex gap-1 items-center"
          iconClassName="!size-4"
        />
      </li>
    ))}
  </menu>
);
